export default __webpack_public_path__ + "0226a8954e2b953d97bc6f12756b9031.svg";